import React, { useEffect, useState } from 'react'

import PerformanceCache from './util/PerformanceCache'
import NadheoPlaceMap from './NadheoPlaceMap'
import { useTranslation } from 'react-i18next'

export default function NadheoEmbeddedPlaceMap(props) {
  let {show, place, startTime} = props;

  const [performance, setPerformance] = useState();
  const [seats, setSeats] = useState();

  useEffect(()=>{
    PerformanceCache.retrievePerformance({"show.name": show, "place.name": place, "start.time": startTime})
      .then((performance)=> {
        setPerformance(performance);
      })
      .catch((e)=> {
        console.log(e);
      })
  }, [show, place, startTime]);

  useEffect(() => {
    if (performance !== undefined && !performance["free.placement"]) {
      PerformanceCache.retrieveNadheoPlaceSeats(performance["performance.ref"])
        .then((s)=> {
          setSeats(s);
        })
        .catch((e)=> {
          console.log(e);
        })
    }
  }, [performance])

  const { t } = useTranslation(["booking", "common"]);

  if (performance === undefined || seats === undefined) return t("common:Chargement en cours");
  return (
    <SeatMap placeName={performance["performance.ref"]["place.name"]}
             seats={seats}/>
  );
}

function SeatMap(props) {
  const {seats, placeName} = props;
  let seatCategories = seats.seatCategories;
  let latestCategoryColourHexValue = "White";
  seatCategories.sort();
  let step = 24;
  let latestCategoryColour = 255+step;
  seatCategories.forEach(() => {
    latestCategoryColour = latestCategoryColour - step;
    let hexValue = Math.abs(latestCategoryColour).toString(16).padStart(2, '0');
    latestCategoryColourHexValue = "#"+hexValue+hexValue+hexValue;
  });
  return (
    <NadheoPlaceMap width="100%"
                    place={placeName}
                    freeColour="#ffffff"
                    freeColourLastCategory={latestCategoryColourHexValue}
                    paidColour="Maroon"
                    bookedColour="Maroon"
                    bufferedColour="Maroon"
                    highlightedColour="Blue"
                    isolatedColour="Red"
                    showLegend={false}
                    seats={seats}
  />);
}
